/**
 * @voltxampere/schema — primitive building blocks
 *
 * Shared Zod primitives used by every entity schema. Defined once here so
 * SemverSchema, UUIDSchema, PointSchema, and RectSchema have exactly one
 * canonical shape per SPECS §1.1.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
/**
 * Semantic-version string, per SPECS §1.1. Accepts `1.2.3` and
 * `1.2.3-beta.1` style pre-release suffixes.
 */
export const SemverSchema = z.string().regex(/^\d+\.\d+\.\d+(-[a-z0-9.]+)?$/);
/**
 * UUID (v1-v5), per SPECS §1.1 — used for `Circuit.id`.
 */
export const UUIDSchema = z.string().uuid();
/**
 * 2D point with finite numeric coordinates, per SPECS §1.1.
 * Finite excludes NaN, +Infinity, -Infinity.
 */
export const PointSchema = z.object({
    x: z.number().finite(),
    y: z.number().finite(),
});
/**
 * Axis-aligned rectangle with finite origin and positive size,
 * per SPECS §1.1.
 */
export const RectSchema = z.object({
    x: z.number().finite(),
    y: z.number().finite(),
    width: z.number().positive(),
    height: z.number().positive(),
});
//# sourceMappingURL=_primitives.js.map